module.exports = __webpack_public_path__ + "img/icon-goods-cart.6998c9a7.svg";